(function (window) {
  if (window.TodayMerchQuantityPricing) return;

  function toInteger(value, fallback) {
    var parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : (fallback === undefined ? 0 : fallback);
  }

  function getAttributeValue(source, key) {
    if (!source) return null;

    if (typeof source.getAttribute === 'function') {
      var attributeValue = source.getAttribute(key);
      return attributeValue == null ? null : attributeValue;
    }

    if (Object.prototype.hasOwnProperty.call(source, key)) {
      return source[key];
    }

    return null;
  }

  function normalizeTiers(tiers) {
    if (!Array.isArray(tiers)) return [];

    var normalized = tiers
      .map(function (tier) {
        return {
          qty: toInteger(tier && tier.qty, 0),
          unit_price_cents: toInteger(tier && (tier.unit_price_cents || tier.unitPriceCents), 0)
        };
      })
      .filter(function (tier) {
        return tier.qty > 0 && tier.unit_price_cents > 0;
      })
      .sort(function (a, b) {
        return a.qty - b.qty;
      });

    var deduped = [];
    normalized.forEach(function (tier) {
      var previous = deduped[deduped.length - 1];
      if (previous && previous.qty === tier.qty) {
        previous.unit_price_cents = Math.min(previous.unit_price_cents, tier.unit_price_cents);
        return;
      }
      deduped.push(tier);
    });

    return deduped;
  }

  function serializeTiers(tiers) {
    return JSON.stringify(normalizeTiers(tiers));
  }

  function parseTiers(serialized) {
    if (!serialized) return [];
    if (Array.isArray(serialized)) return normalizeTiers(serialized);

    var candidates = [serialized];
    if (typeof serialized === 'string') {
      try {
        candidates.push(decodeURIComponent(serialized));
      } catch (error) {}
    }

    for (var i = 0; i < candidates.length; i += 1) {
      try {
        return normalizeTiers(JSON.parse(candidates[i]));
      } catch (error) {}
    }

    return [];
  }

  function normalizeRules(rules) {
    rules = rules || {};
    var min = Math.max(1, toInteger(rules.min, 1));
    var step = Math.max(1, toInteger(rules.step || rules.increment, 1));
    var max = rules.max == null || rules.max === '' ? null : toInteger(rules.max, null);
    return { min: min, step: step, max: Number.isFinite(max) && max > 0 ? max : null };
  }

  function getRulesFromAttributes(source, fallbackRules) {
    var fallback = normalizeRules(fallbackRules);

    var min = getAttributeValue(source, 'data-min');
    if (min == null || min === '') min = getAttributeValue(source, 'min');
    if (min == null || min === '') min = fallback.min;

    var increment = getAttributeValue(source, 'step');
    if (increment == null || increment === '') increment = getAttributeValue(source, 'data-step');
    if (increment == null || increment === '') increment = getAttributeValue(source, 'increment');
    if (increment == null || increment === '') increment = fallback.step;

    var max = getAttributeValue(source, 'max');
    if (max == null || max === '') max = getAttributeValue(source, 'data-max');
    if (max == null || max === '') max = fallback.max;

    return normalizeRules({
      min: min,
      increment: increment,
      max: max
    });
  }

  function normalizeQuantity(rawQuantity, rules, mode) {
    var normalizedRules = normalizeRules(rules);
    var quantity = toInteger(rawQuantity, normalizedRules.min);
    var roundMode = mode || 'up';

    if (quantity < normalizedRules.min) quantity = normalizedRules.min;

    if (normalizedRules.step > 1) {
      var delta = quantity - normalizedRules.min;
      if (delta < 0) {
        quantity = normalizedRules.min;
      } else {
        var steps = roundMode === 'down' ? Math.floor(delta / normalizedRules.step) : Math.ceil(delta / normalizedRules.step);
        quantity = normalizedRules.min + steps * normalizedRules.step;
      }
    }

    if (normalizedRules.max != null && quantity > normalizedRules.max) {
      quantity = normalizedRules.max;
      if (normalizedRules.step > 1 && quantity > normalizedRules.min) {
        var maxDelta = quantity - normalizedRules.min;
        quantity = normalizedRules.min + Math.floor(maxDelta / normalizedRules.step) * normalizedRules.step;
      }
      if (quantity < normalizedRules.min) quantity = normalizedRules.min;
    }

    return quantity;
  }

  function getAppliedTier(quantity, tiers) {
    var normalizedTiers = normalizeTiers(tiers);
    if (!normalizedTiers.length) return null;
    var appliedTier = normalizedTiers[0];
    normalizedTiers.forEach(function (tier) {
      if (tier.qty <= quantity) appliedTier = tier;
    });
    return appliedTier;
  }

  function computeDiscountPct(baseUnitPriceCents, unitPriceCents) {
    if (!baseUnitPriceCents || unitPriceCents >= baseUnitPriceCents) return 0;
    return Math.max(0, Math.round(((baseUnitPriceCents - unitPriceCents) / baseUnitPriceCents) * 100));
  }

  function computeState(options) {
    var tiers = normalizeTiers(options && options.tiers);
    if (!tiers.length) return null;
    var rules = normalizeRules(options && options.rules);
    var quantity = normalizeQuantity(options && options.quantity, rules, options && options.quantityMode);
    var appliedTier = getAppliedTier(quantity, tiers) || tiers[0];
    var baseTier = tiers[0];
    return {
      quantity: quantity,
      sourceCurrency: options && options.sourceCurrency || getBaseCurrency(),
      appliedTierQty: appliedTier.qty,
      unitPriceCents: appliedTier.unit_price_cents,
      totalCents: quantity * appliedTier.unit_price_cents,
      discountPct: computeDiscountPct(baseTier.unit_price_cents, appliedTier.unit_price_cents),
      pricingMode: quantity === appliedTier.qty ? 'tier' : 'custom',
      tiers: tiers,
      rules: rules
    };
  }

  function getRulesFromItem(item) {
    item = item || {};
    var properties = item.properties || {};
    var quantityRule = item.quantity_rule || {};
    var moq = properties._moq != null ? toInteger(properties._moq, 1) : 1;
    return normalizeRules({
      min: Math.max(moq, toInteger(quantityRule.min, 1)),
      increment: quantityRule.increment,
      max: quantityRule.max
    });
  }

  function isSupplierPricing(properties) {
    properties = properties || {};
    return properties._fee_mode === 'separate' || properties._pricing_mode === 'supplier_estimate' || properties._pricing_mode === 'supplier_quote' || properties._pricing_mode === 'personalization_quote' || properties._pricing_mode === 'quote_required'
      || Object.keys(properties).some(function (key) { return key.indexOf('_xd_') === 0 || key.indexOf('_personalization_') === 0; });
  }

  function supplierInteger(value) {
    if (typeof value !== 'number' && (typeof value !== 'string' || !/^[1-9]\d*$/.test(value))) return null;
    var parsed = Number(value);
    return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null;
  }

  // A priority is a quote estimate for this pilot only; it never authorizes checkout.
  function priorityState(item, baseTotalCents) {
    var properties = item.properties || {};
    var productId = String(item.product_id || item.product && item.product.id || '');
    var variantId = String(item.variant_id || item.variant && item.variant.id || item.id || '');
    if (productId !== '15411282837890' || variantId !== '56962772337026') return null;
    var keys = ['_tm_priority_version', '_tm_production_priority', '_tm_priority_rate_bps',
      '_tm_priority_base_total_cents', '_tm_priority_surcharge_cents', '_tm_priority_total_cents'];
    if (!keys.some(function (key) { return properties[key] != null && properties[key] !== ''; })) return null;
    var priority = properties._tm_production_priority;
    var rate = priority === 'express' ? 1000 : 0;
    var surcharge = priority === 'express' ? Math.round(baseTotalCents / 10) : 0;
    var total = baseTotalCents + surcharge;
    var valid = properties._tm_priority_version === '1' && (priority === 'standard' || priority === 'express')
      && properties._tm_priority_rate_bps === String(rate)
      && Number.isSafeInteger(baseTotalCents) && baseTotalCents > 0 && Number.isSafeInteger(total)
      && properties._tm_priority_base_total_cents === String(baseTotalCents)
      && properties._tm_priority_surcharge_cents === String(surcharge)
      && properties._tm_priority_total_cents === String(total);
    return { valid: valid, priority: priority, surchargeCents: surcharge, totalCents: total };
  }

  function supplierNonnegative(value) {
    if (typeof value !== 'number' && (typeof value !== 'string' || !/^(0|[1-9]\d*)$/.test(value))) return null;
    var parsed = Number(value);
    return Number.isSafeInteger(parsed) && parsed >= 0 ? parsed : null;
  }

  function separatePriorityValid(properties, quantity, unit, technical, preparation, total) {
    if (!properties._tm_priority_version) return true;
    var baseUnit = supplierInteger(properties._tm_priority_base_unit_price_cents);
    var baseItems = supplierInteger(properties._tm_priority_base_items_total_cents);
    var baseTechnical = supplierNonnegative(properties._tm_priority_base_technical_fees_cents);
    var basePreparation = supplierNonnegative(properties._tm_priority_base_preparation_fees_cents);
    var baseTotal = supplierInteger(properties._tm_priority_base_total_cents);
    var priority = properties._tm_production_priority;
    var uplift = function (value) { return priority === 'express' ? Math.round(value * 1.1) : value; };
    return properties._tm_priority_version === '2' && (priority === 'standard' || priority === 'express')
      && properties._tm_priority_rate_bps === (priority === 'express' ? '1000' : '0')
      && baseUnit !== null && baseItems === baseUnit * quantity && baseTechnical !== null && basePreparation !== null
      && Number.isSafeInteger(baseTotal) && baseTotal === baseItems + baseTechnical + basePreparation
      && unit === uplift(baseUnit) && technical === uplift(baseTechnical) && preparation === uplift(basePreparation)
      && supplierNonnegative(properties._tm_priority_surcharge_cents) === total - baseTotal
      && supplierInteger(properties._tm_priority_total_cents) === total;
  }

  function supplierState(item, allowExpiredSnapshot) {
    var properties = item.properties || {};
    var personalized = properties._personalization_pricing === '1' || properties._pricing_mode === 'personalization_quote';
    var estimate = !personalized && properties._pricing_mode === 'supplier_estimate' && properties._xd_estimated === '1' && properties._fee_mode === 'separate';
    var quoteMode = personalized ? 'personalization_quote' : estimate ? 'supplier_estimate' : 'supplier_quote';
    var quantity = supplierInteger(item.quantity);
    var quotedQuantity = supplierInteger(personalized ? properties._personalization_quote_quantity : estimate ? properties._xd_estimate_quantity : properties._xd_quote_quantity);
    var unitPriceCents = supplierInteger(properties._applied_unit_price_cents);
    var validUntil = personalized ? properties._personalization_quote_valid_until : estimate ? properties._xd_estimate_valid_until : properties._xd_quote_valid_until;
    var validUntilMs = typeof validUntil === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(?:Z|[+-]\d{2}:\d{2})$/.test(validUntil)
      ? Date.parse(validUntil) : NaN;
    var separate = properties._fee_mode === 'separate';
    var itemsTotal = quantity * unitPriceCents;
    var technical = separate ? supplierNonnegative(properties._technical_fees_cents) : 0;
    var preparation = separate ? supplierNonnegative(properties._preparation_fees_cents) : 0;
    var total = itemsTotal + technical + preparation;
    var feesValid = separate ? technical !== null && preparation !== null
      && supplierNonnegative(properties._items_total_price_cents) === itemsTotal
      && supplierNonnegative(properties._total_price_cents) === total && Number.isSafeInteger(total)
      : !properties._fee_mode;
    var valid = feesValid && (!separate || separatePriorityValid(properties, quantity, unitPriceCents, technical, preparation, total)) && properties._pricing_mode === quoteMode && properties._pricing_currency === 'EUR'
      && (!personalized || properties._personalization_quote_only === '1')
      && quantity !== null && quotedQuantity === quantity && unitPriceCents !== null
      && Number.isSafeInteger(quantity * unitPriceCents) && Number.isFinite(validUntilMs) && (validUntilMs > Date.now() || allowExpiredSnapshot === true && separate);
    var baseTotalCents = quantity * unitPriceCents;
    var priority = separate ? null : priorityState(item, baseTotalCents);
    if (priority && !priority.valid) valid = false;
    var totalCents = priority ? priority.totalCents : baseTotalCents;
    return {
      priorityApplied: !!(valid && priority),
      priority: valid && priority ? priority.priority : null,
      prioritySurchargeCents: valid && priority ? priority.surchargeCents : null,
      baseUnitPriceCents: valid ? unitPriceCents : null,
      baseTotalCents: valid ? baseTotalCents : null,
      valid: valid,
      ...(valid && validUntilMs <= Date.now() ? { displayOnly: true, requiresRequote: true, validUntil: validUntil } : {}),
      quantity: quantity,
      sourceCurrency: 'EUR',
      appliedTierQty: valid ? quantity : null,
      unitPriceCents: valid ? (priority ? totalCents / quantity : unitPriceCents) : null,
      totalCents: valid ? (separate ? total : totalCents) : null,
      ...(separate ? { feeMode: 'separate', itemsTotalPriceCents: valid ? itemsTotal : null,
        technicalFeesCents: valid ? technical : null, preparationFeesCents: valid ? preparation : null,
        totalPriceCents: valid ? total : null } : {}),
      discountPct: 0,
      pricingMode: valid ? quoteMode : 'quote_required',
      tiers: [],
      rules: getRulesFromItem(item)
    };
  }

  function getStateForLineItem(item) {
    item = item || {};
    var properties = item.properties || {};
    if (isSupplierPricing(properties)) return supplierState(item);
    if (properties._pricing_native === true || properties._pricing_native === 'true') return null;
    var tiers = parseTiers(properties._pricing_tiers);
    if (tiers.length) {
      return computeState({
        quantity: item.quantity,
        sourceCurrency: properties._pricing_currency || getBaseCurrency(),
        tiers: tiers,
        rules: getRulesFromItem(item),
        quantityMode: 'up'
      });
    }
    var unitPriceCents = toInteger(properties._applied_unit_price_cents, 0);
    if (unitPriceCents > 0) {
      var quantity = normalizeQuantity(item.quantity, getRulesFromItem(item), 'up');
      return {
        quantity: quantity,
        sourceCurrency: properties._pricing_currency || getBaseCurrency(),
        appliedTierQty: toInteger(properties._applied_tier_qty, quantity),
        unitPriceCents: unitPriceCents,
        totalCents: quantity * unitPriceCents,
        discountPct: toInteger(properties._applied_discount_pct, 0),
        pricingMode: properties._pricing_mode || 'custom',
        tiers: [],
        rules: getRulesFromItem(item)
      };
    }
    return null;
  }

  function buildUpdatedProperties(properties, quantity, rules) {
    var nextProperties = Object.assign({}, properties || {});
    if (isSupplierPricing(nextProperties)) {
      var supplierQuote = supplierState({ properties: nextProperties, quantity: quantity, quantity_rule: rules });
      if (supplierQuote.valid) return nextProperties;
      nextProperties._pricing_mode = 'quote_required';
      nextProperties._pricing_native = 'false';
      ['_pricing_tiers', '_applied_tier_qty', '_applied_unit_price_cents', '_applied_discount_pct', '_xd_quote_quantity', '_xd_quote_valid_until', '_personalization_quote_quantity', '_personalization_quote_valid_until', '_xd_estimate_quantity', '_xd_estimate_valid_until', '_fee_mode', '_items_total_price_cents', '_technical_fees_cents', '_preparation_fees_cents', '_preparation_unit_price_micro', '_total_price_cents', '_tm_priority_base_total_cents', '_tm_priority_surcharge_cents', '_tm_priority_total_cents', '_tm_priority_base_unit_price_cents', '_tm_priority_base_items_total_cents', '_tm_priority_base_technical_fees_cents', '_tm_priority_base_preparation_fees_cents'].forEach(function (key) {
        nextProperties[key] = '';
      });
      return nextProperties;
    }
    if (nextProperties._pricing_native === true || nextProperties._pricing_native === 'true') return null;
    var tiers = parseTiers(nextProperties._pricing_tiers);
    if (!tiers.length) return null;
    var state = computeState({
      quantity: quantity,
      tiers: tiers,
      rules: rules || { min: nextProperties._moq, increment: 1, max: null },
      quantityMode: 'up'
    });
    if (!state) return null;
    nextProperties._pricing_currency = nextProperties._pricing_currency || getBaseCurrency();
    nextProperties._applied_tier_qty = String(state.appliedTierQty);
    nextProperties._applied_unit_price_cents = String(state.unitPriceCents);
    nextProperties._applied_discount_pct = String(state.discountPct);
    nextProperties._pricing_mode = state.pricingMode;
    nextProperties._pricing_tiers = serializeTiers(state.tiers || tiers);
    if (nextProperties._moq == null && state.rules && state.rules.min) nextProperties._moq = String(state.rules.min);
    return nextProperties;
  }

  function getDisplayPricing(item, options) {
    // Cart display may retain a complete snapshot; quote and update paths stay strict.
    var estimated = options && options.allowExpiredSnapshot === true && isSupplierPricing(item && item.properties)
      ? supplierState(item, true) : getStateForLineItem(item);
    if (estimated) {
      var sourceCurrency = estimated.sourceCurrency || getBaseCurrency();
      if (estimated.priorityApplied) {
        // Round/conversion happens on the full line once, never on its derived unit amount.
        var convertedTotal = window.TodayMerchMoney
          ? window.TodayMerchMoney.convert(estimated.totalCents, sourceCurrency)
          : sourceCurrency === getCurrency() ? estimated.totalCents : null;
        var priorityValid = Number.isSafeInteger(convertedTotal) && convertedTotal > 0;
        return {
          estimated: true, valid: priorityValid, priorityApplied: true, priority: estimated.priority,
          currency: getCurrency(), sourceCurrency: sourceCurrency,
          sourceUnitPriceCents: estimated.unitPriceCents, sourceLinePriceCents: estimated.totalCents,
          unitPriceCents: priorityValid ? convertedTotal / estimated.quantity : null,
          linePriceCents: priorityValid ? convertedTotal : null,
          discountPct: 0, appliedTierQty: estimated.appliedTierQty, pricingMode: estimated.pricingMode
        };
      }
      var convertedUnit = estimated.valid === false ? null : window.TodayMerchMoney
        ? window.TodayMerchMoney.convert(estimated.unitPriceCents, sourceCurrency)
        : sourceCurrency === getCurrency() ? estimated.unitPriceCents : null;
      if ((estimated.pricingMode === 'supplier_quote' || estimated.pricingMode === 'supplier_estimate' || estimated.pricingMode === 'personalization_quote') && (!Number.isSafeInteger(convertedUnit) || convertedUnit <= 0 || !Number.isSafeInteger(convertedUnit * estimated.quantity))) convertedUnit = null;
      var separate = estimated.feeMode === 'separate';
      var convertFee = function (value) { return window.TodayMerchMoney ? window.TodayMerchMoney.convert(value, sourceCurrency) : sourceCurrency === getCurrency() ? value : null; };
      var technical = separate && convertedUnit != null ? convertFee(estimated.technicalFeesCents) : null;
      var preparation = separate && convertedUnit != null ? convertFee(estimated.preparationFeesCents) : null;
      var itemsTotal = convertedUnit == null ? null : convertedUnit * estimated.quantity;
      var total = separate ? itemsTotal + technical + preparation : itemsTotal;
      if (separate && (![technical, preparation, total].every(function (value) { return Number.isSafeInteger(value) && value >= 0; })
        || convertedUnit == null)) { convertedUnit = null; itemsTotal = null; total = null; technical = null; preparation = null; }
      return {
        estimated: true,
        ...(estimated.displayOnly ? { displayOnly: true, requiresRequote: true, validUntil: estimated.validUntil } : {}),
        valid: convertedUnit != null,
        currency: getCurrency(),
        sourceCurrency: sourceCurrency,
        sourceUnitPriceCents: estimated.unitPriceCents,
        sourceLinePriceCents: estimated.totalCents,
        unitPriceCents: convertedUnit,
        linePriceCents: total,
        ...(separate ? { feeMode: 'separate', itemsTotalPriceCents: itemsTotal, technicalFeesCents: technical,
          preparationFeesCents: preparation, totalPriceCents: total,
          sourceItemsTotalPriceCents: estimated.itemsTotalPriceCents, sourceTechnicalFeesCents: estimated.technicalFeesCents,
          sourcePreparationFeesCents: estimated.preparationFeesCents, sourceTotalPriceCents: estimated.totalPriceCents } : {}),
        discountPct: estimated.discountPct,
        appliedTierQty: estimated.appliedTierQty,
        pricingMode: estimated.pricingMode
      };
    }
    return {
      estimated: false,
      valid: true,
      currency: getCurrency(),
      sourceCurrency: getCurrency(),
      unitPriceCents: toInteger(item && item.final_price, 0),
      linePriceCents: toInteger(item && item.final_line_price, 0),
      discountPct: 0,
      appliedTierQty: null,
      pricingMode: 'native'
    };
  }

  function getLocale() {
    var locale = (
      (window.Shopify && (window.Shopify.locale || (window.Shopify.routes && window.Shopify.routes.locale))) ||
      (typeof document !== 'undefined' && document.documentElement && document.documentElement.lang) ||
      'fr-FR'
    );

    if (locale === 'fr') return 'fr-FR';
    if (locale === 'en') return 'en-US';
    if (locale === 'de') return 'de-DE';
    if (locale === 'es') return 'es-ES';
    if (locale === 'it') return 'it-IT';
    if (locale === 'pt') return 'pt-PT';
    return locale;
  }

  function getBaseCurrency() {
    return window.TodayMerchMoney ? window.TodayMerchMoney.baseCurrency() : window.FoxTheme && window.FoxTheme.settings && window.FoxTheme.settings.moneyBaseCurrency || 'EUR';
  }

  function getCurrency() {
    if (window.TodayMerchMoney) return window.TodayMerchMoney.activeCurrency();
    return (
      (window.Shopify && window.Shopify.currency && (window.Shopify.currency.active || window.Shopify.currency.current)) ||
      (window.FoxTheme && window.FoxTheme.settings && window.FoxTheme.settings.moneyCurrency) ||
      (typeof document !== 'undefined' && document.documentElement && typeof document.documentElement.getAttribute === 'function' && document.documentElement.getAttribute('data-currency')) ||
      'EUR'
    );
  }

  function formatMoney(cents, format, sourceCurrency, quantity) {
    if (window.TodayMerchMoney) return window.TodayMerchMoney.format(cents, { sourceCurrency: sourceCurrency, quantity: quantity });
    var amount = Number(cents || 0) / 100;
    var locale = getLocale();
    var currency = getCurrency();

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {}

    if (window.FoxTheme && window.FoxTheme.Currency && typeof window.FoxTheme.Currency.formatMoney === 'function') {
      return window.FoxTheme.Currency.formatMoney(cents, format || window.FoxTheme.settings.moneyFormat);
    }

    return amount.toFixed(2) + ' ' + currency;
  }

  window.TodayMerchQuantityPricing = {
    toInteger: toInteger,
    normalizeTiers: normalizeTiers,
    serializeTiers: serializeTiers,
    parseTiers: parseTiers,
    normalizeRules: normalizeRules,
    getRulesFromAttributes: getRulesFromAttributes,
    normalizeQuantity: normalizeQuantity,
    getAppliedTier: getAppliedTier,
    computeDiscountPct: computeDiscountPct,
    computeState: computeState,
    getRulesFromItem: getRulesFromItem,
    isSupplierPricing: isSupplierPricing,
    getStateForLineItem: getStateForLineItem,
    buildUpdatedProperties: buildUpdatedProperties,
    getDisplayPricing: getDisplayPricing,
    formatMoney: formatMoney,
    getBaseCurrency: getBaseCurrency,
    getCurrency: getCurrency
  };
})(window);
